import classnames from "classnames";
import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import SmoothCollapse from "react-smooth-collapse";
import { routes } from "src/constants/routes";
import { IAppState } from "src/models/state";
import { IUser } from "src/models/user";
import { IAsyncState } from "src/state/action";
import { logout } from "src/state/login/actions";

// #region -------------- Interfaces -------------------------------------------------------------------

interface IStateProps {
  currentPath: string;
  currentUser: IAsyncState<IUser>;
}

interface IDispatchProps {
  onLogoutClick(): void;
}

interface IOwnProps {}

interface IProps extends IStateProps, IDispatchProps, IOwnProps {}

interface IState {
  isOpen: boolean;
}

interface ILink {
  title: string;
  path: string;
}

// #endregion

// #region -------------- Links -------------------------------------------------------------------

const links: ILink[] = [
  {
    title: "Main",
    path: routes.manager,
  },
  {
    title: "Report Builder Component",
    path: routes.builder,
  },
  {
    title: "BizCharts",
    path: routes.ExampleBizCharts,
  },
  {
    title: "Chart.js",
    path: routes.ExampleChartsJS,
  },
];

// #endregion

// #region -------------- Component -------------------------------------------------------------------

class NavBar extends React.Component<IProps, IState> {
  private navbar: HTMLDivElement;

  public constructor(props: IProps) {
    super(props);

    this.state = {
      isOpen: false,
    };
  }

  public componentDidMount() {
    window.addEventListener("click", this.onWindowClick);
  }

  public componentWillUnmount() {
    window.removeEventListener("click", this.onWindowClick);
  }

  public render() {
    return (
      <div className="rb-navbar" ref={(ref) => (this.navbar = ref)}>
        <nav className="hidden-xs">
          {this.renderLeftNavItems()}
          {/* 
          Commented due to removal of Login feature
          this.renderRightNavItem() 
          */}
        </nav>

        {this.renderMobileMenu()}
      </div>
    );
  }

  private renderMobileMenu() {
    return (
      <div className="rb-mobile-navbar visible-xs">
        <div>
          <a onClick={this.onMobileButtonClick}>
            <div
              className="fa fa-bars"
              style={{ color: "#343434", fontSize: 22 }}
            />
          </a>
        </div>

        <div className="rb-mobile-menu">
          <SmoothCollapse expanded={this.state.isOpen}>
            {this.renderLeftNavItems()}
            {/* 
            Commented due to removal of Login feature
            this.renderRightNavItem()
            */}
          </SmoothCollapse>
        </div>
      </div>
    );
  }

  private toggleMenu = (value?: boolean) => {
    const willBeOpen =
      value === true || value === false ? value : !this.state.isOpen;

    if (willBeOpen === this.state.isOpen) {
      return;
    }

    this.setState({
      isOpen: willBeOpen,
    });
  };

  private onMobileButtonClick = () => {
    this.toggleMenu();
  };

  private onWindowClick = (event) => {
    const isClickOutsideMenu = !this.navbar.contains(event.target);

    if (isClickOutsideMenu) {
      this.toggleMenu(false);
    }
  };

  private renderLeftNavItems = () => {
    const { currentPath } = this.props;

    return links.map((link, index) => {
      const isCurrentRoute = link.path.includes(currentPath);

      return (
        <div
          key={index}
          className={classnames({
            "rb-navbar-item": true,
            active: isCurrentRoute,
            "rb-last-regular-navbar-item": index === links.length - 1,
          })}
        >
          <Link to={link.path}>{link.title}</Link>
        </div>
      );
    });
  };
  /*
    Commented due to removal of Login feature
    private renderRightNavItem = () => {
      const { currentUser } = this.props;
      const currentUserData = currentUser && currentUser.data;
  
      return (
        <Fragment>
          <div className='hidden-xs rb-navbar-item rb-navbar-item-static'>
            <i className='fas fa-user-circle' />
            {currentUserData && currentUserData.userName}
          </div>
          <div className='rb-navbar-item'>
            <a onClick={this.onLogoutClick}>
              <i className='fas fa-sign-out-alt' />
              Log out
            </a>
          </div>
        </Fragment>
      );
    }
  
    private onLogoutClick = () => {
      this.props.onLogoutClick();
    }
  */
}

// #endregion

// #region -------------- Connect -------------------------------------------------------------------

const connected = connect<IStateProps, IDispatchProps, IOwnProps, IAppState>(
  (state) => {
    const { router, login } = state;
    const currentPath = router && router.location && router.location.pathname;

    return {
      currentPath,
      currentUser: login.currentUser,
    };
  },
  (dispatch) => {
    return {
      onLogoutClick: () => dispatch(logout()),
    };
  }
)(NavBar);

export { connected as NavBar };

// #endregion
